import React from 'react';
import { Link } from 'react-router-dom';


const Experiences = () => {
    return(
        <>
        {/* Results Section */}
        <section className="result-section section-padding-three" style={{background: 'url(images/background/01.png) no-repeat', backgroundSize: 'cover'}}>
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="sec-o-title text-center pb-3">
                    <h2 className="transform-uppercase"><span>Decades Of Experience. Real Results</span></h2>
                </div>
                </div>
            </div>
            <div className="row clerfix">
                <div className="col-lg-3">
                <div className="result-details text-center mb-5">
                    <div className="result-atto-name">Alex Jacobson</div>
                    <div className="result-price">$470,000</div>
                    <p> Lorem ipsum dolor sit amet conbt sectetur adipisicing elit, sed eius mod tempor incididunt labore.</p>
                    <Link to="#">Sexual Abuse</Link>
                </div>
                </div>
                <div className="col-lg-3">
                <div className="result-details text-center mb-5">
                    <div className="result-atto-name">ALina Kevin</div>
                    <div className="result-price">$400,000</div>
                    <p> Lorem ipsum dolor sit amet conbt sectetur adipisicing elit, sed eius mod tempor incididunt labore.</p>
                    <Link to="#">Sexual Abuse</Link>
                </div>
                </div>
                <div className="col-lg-3">
                <div className="result-details text-center mb-5">
                    <div className="result-atto-name">Polard Andrew</div>
                    <div className="result-price">$350,000</div>
                    <p> Lorem ipsum dolor sit amet conbt sectetur adipisicing elit, sed eius mod tempor incididunt labore.</p>
                    <Link to="#">Sexual Abuse</Link>
                </div>
                </div>
                <div className="col-lg-3">
                <div className="result-details text-center mb-5">
                    <div className="result-atto-name">Jury Verdict</div>
                    <div className="result-price">$550,000</div>
                    <p> Lorem ipsum dolor sit amet conbt sectetur adipisicing elit, sed eius mod tempor incididunt labore.</p>
                    <Link to="#">Sexual Abuse</Link>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Results Section*/}
        </>
    )
}

export default Experiences;